module.exports = "/assets/site/images/group.png?4f732f56bfff7543e16f9c7e4cf565f6";